import React from "react";
import PageTitle from "components/PageTitle";
import { tracker } from "library/tracker";
import PrimeRmsContainer from "containers/jarivsPrime/PrimeRMS";

const PrimeActionCentre = () => {
  React.useEffect(() => {
    tracker.pageView();
  }, []);

  return (
    <>
      <PageTitle
        heading="Action Centre"
        subheading="Rebalance alerts will appear here"
      />
      <PrimeRmsContainer />
    </>
  );
};

export default PrimeActionCentre;
